import React, { useState } from "react";
import { arrayOf, shape, string, func, object, bool } from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import ReadingStatus from "../ReadingListDownload/reading_status";
import ReadingList from "../ReadingList/index";

const filenameFromUrl = (url) => url.split("/").slice(-1)[0];

const GreatBearOnboarding = ({
  readingList = [],
  markDocumentRead,
  greatBearOnboarding,
  getCompletedDocument,
  greatBearReadingLoading,
}) => {
  const [currentlyReading, setCurrentlyReading] = useState(null);

  const readDocuments =
    (greatBearOnboarding && greatBearOnboarding.readDocuments) || [];

  const readingListWithStatus = readingList.map((download) => ({
    ...download,
    status: readDocuments.includes(filenameFromUrl(download.link))
      ? ReadingStatus.Done
      : ReadingStatus.Todo,
    agreementText:
      "I have read and understood the instructions given and agree to follow them.",
  }));

  return (
    <div className="container py-2">
      <h2>Great Bear Induction Pack</h2>
      <ReadingList
        description="You are required to download and read this induction pack before you start work. Please download this form and read it fully, you do not have to complete the fields. Once you have ticked the box to confirm you have read and understood the induction and agree to the declaration, we will complete the fields on the form e.g. name, signature, date, for you. If you have any queries about the pack, please speak to your line manager."
        isLoading={greatBearReadingLoading}
        readingListWithStatus={readingListWithStatus}
        currentlyReading={currentlyReading}
        setCurrentlyReading={setCurrentlyReading}
        markDocumentRead={markDocumentRead}
        getCompletedDocument={getCompletedDocument}
        isGB={true}
      />
      <div className="w-100 d-flex justify-content-end mt-4">
        <Link to="/profile" className="btn btn-primary px-3">
          Back to My Account
        </Link>
      </div>
    </div>
  );
};

GreatBearOnboarding.propTypes = {
  greatBearOnboarding: object,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  markDocumentRead: func.isRequired,
  getCompletedDocument: func.isRequired,
  greatBearReadingLoading: bool,
};

const mapStateToProps = (state) => ({
  greatBearReadingLoading: state.core.greatBearReading.isLoading,
});

const withRedux = connect(mapStateToProps, null);

export default withRedux(GreatBearOnboarding);
